import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IonRouterOutlet, PopoverController } from '@ionic/angular';
import { BasePage } from 'src/app/core/base-page';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { Community } from 'src/app/data/schema/community';
import { ProfilePopoverComponent } from '../profile-popover/profile-popover.component';
import { CommunityService } from 'src/app/data/service/community.service';
import { CommunitySubscription } from 'src/app/data/schema/cbs/community-subscription';
import { CommunityUser } from 'src/app/data/schema/community-user';
import { AppSettings } from 'src/app/core/configs/app.settings';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BasePage implements OnInit {

  static showWarning = false;

  @Input() title = 'CommuniBee';
  @Input() myCommunities: Community[];
  @Output() searchEvent: EventEmitter<string> = new EventEmitter<string>();

  currCommunityId: number;
  currentSub: CommunitySubscription;
  hideExpired = false;
  showNotification = false;

  private expiredKey = 'dismissed_expired';

  constructor(
    private routerOutlet: IonRouterOutlet,
    private communityService: CommunityService,
    private popoverCtrl: PopoverController,
    authService: AuthenticationService,) {
    super(authService);

  }

  get warningVisible() {
    return HeaderComponent.showWarning;
  }

  get currentCommunity() { return Community.activeCommunity; }

  get currentCommunityName() {
    if (Community.activeCommunity == null || Community.activeCommunity.communityId == 0) {
      return 'Select a Community to Start';
    }

    let name = Community.activeCommunity.name;
    if (this.title != null && this.title.length > 0) {
      name += ' - ' + this.title;
    }

    return name;
  }

  get profile() {
    return this.authService?.profile;
  }

  async ngOnInit() {
    if (this.myCommunities == null && this.authService.profile != null) {
      // only fetch if we are actually logged in and didn't get communities passed in
      this.myCommunities = await Community.getMyCommunities();
    }
    this.currCommunityId = Community.activeCommunity != null ? Community.activeCommunity.communityId : 0;
    if (Community.activeCommunity != null && Community.activeCommunity.communityId > 0) {
      this.currentSub = await CommunitySubscription.getCurrent(true);
    }

    if (this.currentSub != null) {
      this.expiredKey = `dismissed_expired_${this.currentSub.communitySubscriptionId}`;
    }

    this.hideExpired = localStorage.getItem(this.expiredKey) == 'true';

    this.showNotification = localStorage.getItem(`show_notification-${AppSettings.version}`) !== 'false';
  }

  canGoBack() {
    return this.routerOutlet && this.routerOutlet.canGoBack();
  }

  async selectCommunity(changeVal: any) {
    var commId = changeVal.detail.value;
    if (commId == 0) {
      // Special case is if we're on the support tickets page, then we can live without a community
      // selected, if we are launch admin
      if (!ServiceHelper.authSvc.profile?.username?.endsWith('launch57.com')) {
        ServiceHelper.navCtrl.navigateRoot('/home/communities');
      }
    }
    else if (Community.activeCommunity == null || commId != Community.activeCommunity.communityId) {
      await this.communityService.loadCommunity(commId);
      localStorage.setItem('curr_community', commId.toString());
      await CommunityUser.reloadMyProfile();
      ServiceHelper.navCtrl.navigateRoot('/engagement/dashboard');
      CommunitySubscription.getCurrent(true, true);
    }
  }

  async back() {
    const wentBack = await this.routerOutlet.pop();
    if (wentBack === false) {
      history.back();
    }
  }

  dismissNotification() {
    localStorage.setItem(`show_notification-${AppSettings.version}`, 'false');
    this.showNotification = false;
  }

  async showProfilePopover(ev: any) {
    const poopover = await this.popoverCtrl.create({ event: ev, component: ProfilePopoverComponent });
    poopover.present();
  }

  async dismissExpired() {
    const doDismiss = await ServiceHelper.confirmSomething('Subscription Expired', 'Your subscription has expired. You can resubscribe any time from the Subscription page.', 'Cancel', 'Dismiss');
    if (doDismiss) {
      localStorage.setItem(this.expiredKey, 'true');
      this.hideExpired = true;
    }
  }

  goHome() {
    ServiceHelper.navCtrl.navigateRoot('/engagement/dashboard');
  }

  closeWarning() {
    HeaderComponent.showWarning = false;
  }
}
